import { Component } from "vue-property-decorator";
import Vue from "vue";

@Component({})
export default class Error404 extends Vue {
  goToHome() {
    this.$router.push({ name: "root" });
  }
}
